/**
 * Thib Element
 */

import { CONSTANTS } from '@js/global'
import { setRandomPosition, Draggable, zIndexManager} from '@js/utils'

import css from '@css/sass/styles.module.scss'

export class ThibTheCatElement {
  private element: HTMLElement | null = null
  private id: string
  draggable: Draggable | null = null

  constructor(index: number) {
    this.id = `thib${index}`
  }

  setup(): void {
    this.createElement()
    this.setupDragging()
    this.setupHover()
    this.positionRandomly()
  }

  getElement(): HTMLElement | null {
    return this.element
  }

  /* Private methods */

  private createElement(): void {
    this.element = document.createElement('div')
    this.element.id = this.id
    this.element.className = `${css.thumbnail} ${css.unselectable_text}`
    this.element.style.width = `${CONSTANTS.css.boxWidth}px`
    this.element.style.height = `${CONSTANTS.css.boxWidth}px`
    this.element.style.position = 'absolute'
    this.element.style.visibility = 'visible'

    document.body.appendChild(this.element)

    zIndexManager.register(this.id, this.element)
  }

  private setupDragging(): void {
    if (!this.element) return

    this.draggable = new Draggable(this.element, {
      containment: 'window',
      clickThreshold: 5,
      onStart: () => zIndexManager.bringToFront(this.id),
      onDrag:  () => zIndexManager.bringToFront(this.id),
    })
  }

  private setupHover(): void {
    if (!this.element) return

    this.element.addEventListener('mouseenter', () => {
      zIndexManager.bringToFront(this.id)
    })
  }

  private positionRandomly(): void {
    if (!this.element) return

    setRandomPosition(this.element)

    window.addEventListener('resize', () => {
      if (this.element) setRandomPosition(this.element)
    })
  }
}